import React, { useState, useEffect } from 'react';
import {
  Box,
  Heading,
  SimpleGrid,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  VStack,
} from '@chakra-ui/react';

interface Transaccion {
  ID: number;
  RFCReceptor: string;
  usuario:string;
  Concepto: string | null;
  RazonSocial: string;
  MetodoPago: string;
  Monto: number;
  UUID: string | null;
  Fecha: string;
  f_pago:string;
  IDTransacc: string;
  ConceptosTransacciones: Array<{
    ID: number;
    HistorialID: number;
    ClaveProdServ: string;
    ClaveUnidad: string;
    Cantidad: number;
    NoIdentificacion: string;
    Unidad: string;
    Descuento:number;
    TipoDescuento:string;
    Descripcion: string;
    ValorUnitario: number;
    Importe: number;
    ObjImp: string;
    ObjetoImp: string | null;
  }>;
}

const TransaccionDetails: React.FC<{ transaccionId: string }> = ({
  transaccionId,
}) => {
  const [transaccion, setTransaccion] = useState<Transaccion | null>(null);
  const [tipoDescuentoCatalogo, setTipoDescuentoCatalogo] = useState([]);
  const formasPagoSAT: Record<string, string> = {
    '01': 'Efectivo',
    '02': 'Cheque nominativo',
    '03': 'Transferencia electrónica de fondos',
    '04': 'Tarjeta de crédito',
    '28': 'Tarjeta de débito',
  };
  
  useEffect(() => {
    const fetchTransaccion = async () => {
      try {
        const response = await fetch(
          `http://52.91.130.91:5000/api/Transacciones/detalles/${transaccionId}`,
        );
        const data = await response.json();
        setTransaccion(data);

        await fetch('http://52.91.130.91:5001/api/cTipoDescuentoRoutes')
        .then((response) => response.json())
        .then((data) => setTipoDescuentoCatalogo(data))
        .catch((error) =>
          console.error('Error al cargar el catálogo de descuentos:', error),
        );
      } catch (error) {
        console.error('Error fetching transaccion:', error);
      }
    };

    fetchTransaccion();
  }, [transaccionId]);

  if (!transaccion) {
    return <Box>Cargando...</Box>;
  }

  return (
    <Box
      p={6}
      bg="white"
      borderRadius="md"
      boxShadow="md"
      maxW="1000px"
      mx="auto"
    >
      <Heading as="h2" size="lg" mb={6} textAlign="center">
        Detalles de Transacción
      </Heading>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 5 }} spacing={4}>
        <Box>
          <Text fontWeight="bold">ID:</Text>
          <Text>{transaccion.ID}</Text>
        </Box>
        <Box>
          <Text fontWeight="bold">Razón Social:</Text>
          <Text>{transaccion.RazonSocial}</Text>
        </Box>
        <Box>
          <Text fontWeight="bold">Método de Pago:</Text>
          <Text>{formasPagoSAT[transaccion.f_pago] || transaccion.f_pago}</Text>
        </Box>

        <Box>
          <Text fontWeight="bold">RFC:</Text>
          <Text>{transaccion.RFCReceptor}</Text>
        </Box>

        <Box>
          <Text fontWeight="bold">UUID:</Text>
          <Text>{transaccion.UUID}</Text>
        </Box>
        <Box>
          <Text fontWeight="bold">Monto:</Text>
          <Text>
            ${new Intl.NumberFormat('en-US').format(transaccion.Monto)}
          </Text>
        </Box>
        <Box>
          <Text fontWeight="bold">Fecha:</Text>
          <Text>{new Date(transaccion.Fecha).toLocaleString()}</Text>
        </Box>

        <Box>
          <Text fontWeight="bold">Clave Catastral:</Text>
          <Text>{transaccion.IDTransacc || 'N/A'}</Text>
        </Box>
        <Box>
          <Text fontWeight="bold">Usuario:</Text>
          <Text>{transaccion.usuario || 'N/A'}</Text>
        </Box>
        {/* <Box>
          <Text fontWeight="bold">ID Transacción:</Text>
          <Text>{transaccion.IDTransacc}</Text>
        </Box> */}
      </SimpleGrid>
      <Box
        p={6}
        bg="white"
        borderRadius="md"
        boxShadow="md"
        maxW="1000px"
        mx="auto"
        overflowX={'auto'}
      >
        <Heading as="h6" size="md" mb={4}>
          Conceptos de Transacciones
        </Heading>
        <Table
          variant="striped"
          colorScheme="teal"
          overflowX={'auto'}
          overflowY={'auto'}
        >
          <Thead>
            <Tr>
              <Th>Clave Producto/Servicio</Th>
              <Th>Descripción</Th>
              <Th>Valor Unitario</Th>
              
              <Th>Cantidad</Th>
              <Th>Unidad</Th>
              <Th>Descuento</Th>
              <Th>Tipo Descuento</Th>
              <Th>Subtotal</Th>
              <Th>Total</Th>
            </Tr>
          </Thead>
          <Tbody>
            {transaccion.ConceptosTransacciones.map((concepto) => (
              <Tr key={concepto.ID}>
                <Td>{concepto.ClaveProdServ}</Td>
                <Td>{concepto.Descripcion}</Td>
                <Td>${concepto.ValorUnitario}</Td>

                <Td>{concepto.Cantidad}</Td>
                <Td>{concepto.Unidad}</Td>
                <Td>%{concepto.Descuento}</Td>
                <Td>
  {
    tipoDescuentoCatalogo.find(
      (item) => item.id === parseInt(concepto.TipoDescuento)
    )?.descripcion || "N/A"
  }
</Td>


                <Td>${concepto.Cantidad*concepto.ValorUnitario}</Td>

                <Td>
                  $
                  {new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(concepto.Importe)}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default TransaccionDetails;
